<dx-polar-chart
  class="matrix-chart"
  [dataSource]="personCompetencyMatrixData"
  [useSpiderWeb]="true"
>
  <dxi-series
    type="line"
    argumentField="categoryName"
    valueField="countOfCompletedEvents"
  >
  </dxi-series>
  <dxo-common-series-settings type="line"></dxo-common-series-settings>
  <dxo-tooltip [enabled]="true"></dxo-tooltip>
  <dxo-legend [visible]="false"></dxo-legend>
</dx-polar-chart>
